import PartDetail from "./PartDetail"

export default PartDetail
